import { Upload } from "tus-js-client";

const BUNNY_TUS_ENDPOINT = "https://video.bunnycdn.com/tusupload";
const DEFAULT_LIBRARY_ID = "637172";
const DEFAULT_EXPIRY_BUFFER_SECONDS = 200000;

const uploadFileToBunny = async ({
  videoId,
  presignedSignature,
  file,
  libraryId = DEFAULT_LIBRARY_ID,
  onProgress,
}) => {
  if (!videoId) {
    throw new Error("videoId is required for Bunny upload");
  }

  if (!presignedSignature) {
    throw new Error("presignedSignature is required for Bunny upload");
  }

  if (!file) {
    throw new Error("file is required for Bunny upload");
  }

  const expirationTime =
    Math.floor(Date.now() / 1000) + DEFAULT_EXPIRY_BUFFER_SECONDS;

  return new Promise((resolve, reject) => {
    const videoFileUpload = new Upload(file, {
      endpoint: BUNNY_TUS_ENDPOINT,
      retryDelays: [0, 3000, 5000, 10000, 20000, 60000, 60000],
      headers: {
        AuthorizationSignature: presignedSignature,
        AuthorizationExpire: expirationTime,
        VideoId: videoId,
        LibraryId: libraryId,
      },
      metadata: {
        filename: file.name,
        filetype: file.type,
      },
      onError: (error) => {
        reject(error);
      },
      onProgress: (bytesUploaded, bytesTotal) => {
        const percentage = Number(
          ((bytesUploaded / bytesTotal) * 100).toFixed(2),
        );
        if (onProgress) {
          onProgress({ bytesUploaded, bytesTotal, percentage });
        }
      },
      onSuccess: () => {
        resolve({ videoId });
      },
    });

    videoFileUpload
      .findPreviousUploads()
      .then((previousUploads) => {
        if (previousUploads.length > 0) {
          videoFileUpload.resumeFromPreviousUpload(previousUploads[0]);
        }
        videoFileUpload.start();
      })
      .catch((error) => reject(error));
  });
};

export default uploadFileToBunny;
